import React from 'react';
import styled from 'styled-components';

export interface Adornment {
  className?: string;
  customElement?: React.ReactNode | string;
  position: 'prefix' | 'suffix'
}

export const Adornment = ({ className, customElement, position }: Adornment) => {
  const positionClass = position === 'prefix'? "border-right-0" : "border-left-0"

  return (
    <AdornmentContainer className={`${positionClass} ${className} adornment order-0 d-flex align-items-center px-3 py-2`}>
      {customElement}
    </AdornmentContainer>
  );
};

const AdornmentContainer = styled.span`
  background-color: #F5F5F5;
  color: #A3A3A3;
  font-size: 0.875rem;
  border: 1px solid #ccc;

  svg {
    width: 100%;
    height: 100%;
    max-width: 1rem;
    max-height: 1rem;
  }
`;

export default Adornment;
